import React from 'react';
import { getLocalizedDateTime, getLocalizedString } from '../../localization/LocalizedString';
import './ServiceTable.css';
import formatSeconds from './TimeFormat';

const TaskListItem = ({ currentLanguage, item, isAdmin }) => {
  const {
    companyName,
    totalEndTime,
    totalDuration,
    billed,
    userId,
    additionalFeatures,
    streetAddress,
    city,
    serviceName,
    serviceSiteNo,
    customer: { name: customerName } = {},
  } = item;

  return (
    <tr className="report-table-row_service">
      {isAdmin && (
        <td className="report-table-cell_service">{userId}</td>
      )}
      <td className="report-table-cell_service">{getLocalizedDateTime(new Date(totalEndTime), currentLanguage)}</td>
      <td className="report-table-cell_service">{customerName}</td>
      <td className="report-table-cell_service">{companyName}</td>
      <td className="report-table-cell_service">{streetAddress}</td>
      <td className="report-table-cell_service">{city}</td>
      <td className="report-table-cell_service">{serviceSiteNo}</td>
      <td className="report-table-cell_service">{getLocalizedString(serviceName, currentLanguage)}</td>
      <td className="report-table-cell_service">
        {additionalFeatures == null
          ? additionalFeatures
          : additionalFeatures.join(', ')}
      </td>
      <td className="report-table-cell_service report-table-number-left">{formatSeconds(totalDuration)}</td>
      {isAdmin && !!billed && (
        <td className="report-table-cell_service report-table-number">{getLocalizedDateTime(new Date(totalEndTime), currentLanguage)}</td>
      )}
      {isAdmin && !billed && (
        <td className="report-table-cell_service report-table-number"> - </td>
      )}
    </tr>
  );
};

export default TaskListItem;
